import { Fragment, memo, useEffect, useState } from 'react'

import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { ChevronDownIcon, ChevronUpIcon } from '@/assets'

import { ItemList } from '../ItemList'
import { navigationItems } from '../../../NavigationMenu/NavigationMenu.data'

import { navigationDrawerClasses } from '..'
import { navigationListStyles as styles } from './NavigationList.styles'

interface NavigationListProps {
  isDrawerOpen: boolean
  closeDrawer: (currentState: boolean) => void
}

const NavigationList = ({ isDrawerOpen, closeDrawer }: NavigationListProps) => {
  const [selectedNavItem, setSelectedNavItem] = useState<string>('')

  useEffect(() => {
    if (!isDrawerOpen) {
      setSelectedNavItem('')
    }
  }, [isDrawerOpen])

  return (
    <Box sx={styles.container}>
      {navigationItems.map(({ label, hasDropdown }) => (
        <Fragment key={label}>
          <Box
            sx={styles.navigationItem}
            onClick={() => setSelectedNavItem(label === selectedNavItem ? '' : label)}>
            <Text sx={styles.itemName} className="ellipsis">
              {label}
            </Text>
            {hasDropdown && (
              <>
                {selectedNavItem === label ? (
                  <ChevronUpIcon className={navigationDrawerClasses.chevronIcon} />
                ) : (
                  <ChevronDownIcon className={navigationDrawerClasses.chevronIcon} />
                )}
              </>
            )}
          </Box>

          {label === selectedNavItem && (
            <ItemList selectedNavItem={selectedNavItem} closeDrawer={closeDrawer} />
          )}
        </Fragment>
      ))}
    </Box>
  )
}

export default memo(NavigationList)
